// Remembers that this browser had a signed-in user, so a sign-out the user did not start here
// (logout on another device revoking the session) can be explained. Firebase clears a revoked saved
// user while loading, before reporting any user, so an auth listener never sees signed-in → null.
const kLocalStorageSignedInUidKey = 'paxton.signedInUid'

export function rememberSignedInUser(uid: string) {
  try {
    localStorage.setItem(kLocalStorageSignedInUidKey, uid)
  } catch {
    // Storage can be unavailable (private mode, blocked site data); the modal is a convenience.
  }
}

export function forgetSignedInUser() {
  try {
    localStorage.removeItem(kLocalStorageSignedInUidKey)
  } catch {
    // See rememberSignedInUser.
  }
}

export function hadSignedInUser(): boolean {
  try {
    return localStorage.getItem(kLocalStorageSignedInUidKey) !== null
  } catch {
    return false
  }
}
